import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Avatar,
  TextField,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Agent } from '../../types/agent';

type DuplicateAgentDialogProps = {
  open: boolean;
  onClose: () => void;
  agents: Agent[];
  onSelectAgentToDuplicate: (agentId: string) => void;
};

const DuplicateAgentDialog: React.FC<DuplicateAgentDialogProps> = ({ open, onClose, agents, onSelectAgentToDuplicate }) => {
  const [query, setQuery] = React.useState('');
  const filtered = React.useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return agents;
    return agents.filter(a => (a.name || '').toLowerCase().includes(q) || (a.description || '').toLowerCase().includes(q));
  }, [query, agents]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        Duplicar de outro agente
        <IconButton aria-label="close" onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <TextField fullWidth placeholder="Buscar agente..." value={query} onChange={(e) => setQuery(e.target.value)} sx={{ mb: 2 }} />
        <List sx={{ maxHeight: 360, overflow: 'auto' }}>
          {filtered.map((a) => (
            <ListItemButton key={a.id} onClick={() => onSelectAgentToDuplicate(a.id)}>
              <ListItemIcon>
                <Avatar sx={{ bgcolor: 'primary.main' }}>
                  <ContentCopyIcon fontSize="small" />
                </Avatar>
              </ListItemIcon>
              <ListItemText primary={a.name} secondary={`${a.typeProduct} • ${a.model}`} />
            </ListItemButton>
          ))}
          {filtered.length === 0 && (
            <Box sx={{ textAlign: 'center', color: 'text.secondary', py: 4 }}>
              Nenhum agente encontrado
            </Box>
          )}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default DuplicateAgentDialog;


